exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, ".Table2 .table{display:table;border-collapse:collapse;width:100%}.Table2 .td,.Table2 .th{border:1px solid #999;text-align:center;font-size:1em;font-weight:400}.Table2 a{text-decoration:underline}", "", {"version":3,"sources":["/Users/yuki/Public/wp-admin/src/components/contents/Table2/src/components/contents/Table2/Table2.s.scss"],"names":[],"mappings":"AAEA,eAEI,cAAc,AACd,yBAAyB,AACzB,UAAW,CACZ,AALH,wBAQI,sBAAsB,AACtB,kBAAkB,AAClB,cAAc,AACd,eAAmB,CACpB,AAZH,UAcI,yBAA0B,CAC3B","file":"Table2.s.scss","sourcesContent":["@import '~scss/variables';\n\n.Table2 {\n  .table {\n    display: table;\n    border-collapse: collapse;\n    width: 100%;\n  }\n  .th,\n  .td {\n    border: 1px solid #999;\n    text-align: center;\n    font-size: 1em;\n    font-weight: normal;\n  }\n  a {\n    text-decoration: underline;\n  }\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"minimize":true,"sourceMap":true}!./node_modules/sass-loader/lib/loader.js?{"sourceMap":true}!./src/components/contents/Table2/Table2.s.scss
// module id = 1180
// module chunks = 73